import { ActivityIndicator, Pressable, ScrollView, View } from "react-native";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../components/PlaceText";
import { BasePage } from "../helpers/BasePage";
import { PlaceColors } from "../helpers/PlaceColors";
import { FindifySimpleHeader } from "../components/FindifySimpleHeader";
import { getApiFromModule } from "../helpers/GetContentsByModule";
import { Dropdown } from "react-native-element-dropdown";
import { Camera } from "react-native-camera-kit";
import Icon from "react-native-vector-icons/Ionicons";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyToast } from "../components/FindifyToast";
import uuid from 'react-native-uuid';
import { MobileBOTicketsApi } from "../../../findifyv2-api-ts/mobile/tickets/BOTicketsApi";

export const AdminTicketValidation = ({ navigation, route }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);


    const [validEvents, setValidEvents] = useState<any[]>([]);
    const [ticketCollections, setTicketCollections] = useState<any[]>([]);
    const [enableCameraScan, setEnableCameraScan] = useState(false);
    const [scanningQR, setScanningQR] = useState<Boolean>(false);
    const [eventToScan, setEventToScan] = useState<any>(null);
    const [authData, setAuthData] = useState<any>({});

    // Get events with tickets
    useEffect(() => {
        if (route.params && route.params.authData) {
            setAuthData(route.params.authData);
        }
        getApiFromModule('tickets_collections', findifyDataContext).getList(0, 1000, null, {
            event_id_not: 'null'
        }, null).then((res: any) => {
            const ticketCollections = res.results;
            const events_ids = Array.from(new Set(ticketCollections.map((ticketCollection: any) => ticketCollection.event_id)));

            getApiFromModule('events', findifyDataContext).getList(0, events_ids.length, null, {
                event_id_in: JSON.stringify(events_ids), //events_ids
            }, null).then((eventsData: any) => {
                const events = eventsData.results;
                setTicketCollections(ticketCollections);
                setValidEvents(events);
            });
        })
    }, []);

    if (enableCameraScan) {
        return <ValidateCamera
            findifyDataContext={findifyDataContext}
            validEvents={validEvents}
            setValidEvents={setValidEvents}
            ticketCollections={ticketCollections}
            setTicketCollections={setTicketCollections}
            enableCameraScan={enableCameraScan}
            setEnableCameraScan={setEnableCameraScan}
            scanningQR={scanningQR}
            setScanningQR={setScanningQR}
            eventToScan={eventToScan}
            setEventToScan={setEventToScan}
            authData={authData}
        />
    } else {
        return <SelectEventToValidate
            navigation={navigation}
            findifyDataContext={findifyDataContext}
            validEvents={validEvents}
            setValidEvents={setValidEvents}
            ticketCollections={ticketCollections}
            setTicketCollections={setTicketCollections}
            enableCameraScan={enableCameraScan}
            setEnableCameraScan={setEnableCameraScan}
            scanningQR={scanningQR}
            setScanningQR={setScanningQR}
            eventToScan={eventToScan}
            setEventToScan={setEventToScan}
        />
    }
};


const SelectEventToValidate = ({ navigation, findifyDataContext,
    validEvents,
    setValidEvents,
    ticketCollections,
    setTicketCollections,
    enableCameraScan,
    setEnableCameraScan,
    scanningQR,
    setScanningQR,
    eventToScan,
    setEventToScan, ...props }: any) => {
    const { t } = useTranslation();

    return <BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <FindifySimpleHeader
            isEventLayout
            hideMenu={true}
            title={t('base.tickets.ticket_validation')}
            backgroundColor={PlaceColors(findifyDataContext).background.get()}
            navigation={navigation} />


        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{

                backgroundColor: PlaceColors(findifyDataContext).background.get(),
                margin: 10,
                gap: 20,
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Dropdown
                data={validEvents}
                style={{
                    borderColor: PlaceColors(findifyDataContext).secondary.get(),
                    borderRadius: 10,
                    borderWidth: 1,
                    paddingHorizontal: 10,
                    marginBottom: 10,
                }}
                placeholder={t('base.tickets.select_event')}
                itemTextStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                inputSearchStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                placeholderStyle={{ color: PlaceColors(findifyDataContext).text.get() }}
                selectedTextStyle={{ backgroundColor: PlaceColors(findifyDataContext).background.get(), color: PlaceColors(findifyDataContext).text.get() }}
                // containerStyle={{backgroundColor: 'pink'}}
                itemContainerStyle={{ backgroundColor: PlaceColors(findifyDataContext).background.get() }}
                labelField={`name.${findifyDataContext.language}`}
                value={eventToScan}
                valueField={'event_id'} onChange={(selected: any) => {
                    if (selected === eventToScan) {
                        setEventToScan(null)
                    } else {
                        setEventToScan(selected);
                    }
                }} />

            <Pressable
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderColor: PlaceColors(findifyDataContext).secondary.get(),
                    borderRadius: 10,
                    borderWidth: 1,
                    padding: 10,
                }}
                onPress={() => {
                    // Open qr validation modal
                    if (eventToScan) {

                        setEnableCameraScan(true);
                    } else {
                        FindifyToast({
                            id: uuid.v4(),
                            visibilityTime: 3000,
                            type: 'error',
                            message: t('tickets.validation_select_event_to_validate'),
                        })
                    }
                }}
            >
                <PlaceText
                    style={{
                        color: PlaceColors(findifyDataContext).text.get()
                    }}>{t('base.tickets.validate_ticket')}</PlaceText>
            </Pressable>
        </ScrollView >
    </BasePage >
}


const ValidateCamera = ({ findifyDataContext,
    validEvents,
    setValidEvents,
    ticketCollections,
    setTicketCollections,
    enableCameraScan,
    setEnableCameraScan,
    scanningQR,
    setScanningQR,
    authData,
    eventToScan,
    setEventToScan, ...props }: any) => {

    const insets = useSafeAreaInsets();
    const ticketValidationApi = new MobileBOTicketsApi();
    const [openModal, setOpenModal] = useState(false);
    const [validatingTicket, setValidatingTicket] = useState(false);
    const [ticketToValidate, setTicketToValidate] = useState<any>(null);
    const [isTicketValid, setIsTicketValid] = useState<boolean | null>(null);
    const [errorValidating, setErrorValidating] = useState<boolean | null>(null);
    const [isTicketFirstValidation, setIsTicketFirstValidation] = useState<boolean | null>(null);
    return <View
        style={{
            flex: 1,
        }}
    >
        <Camera
            showFrame={true}
            frameColor='white'
            scanBarcode={true}
            onReadCode={(code: any) => {
                // console.log('readingCode', code?.nativeEvent?.codeStringValue, scanningQR)
                if (!scanningQR) {
                    setScanningQR(true);
                    const qrValue = code?.nativeEvent?.codeStringValue;
                    if (qrValue) {
                        // QR FOUND - DO SOMETHING
                        setOpenModal(true)
                        setValidatingTicket(true)
                        ticketValidationApi.validate(findifyDataContext, authData,  eventToScan?.event_id.toString(), JSON.stringify({ qrcode: qrValue }), null).then((res: any) => {
                            setValidatingTicket(false);
                            setIsTicketFirstValidation(true);
                            setIsTicketValid(true);
                        }).catch((err: any) => {
                            try {
                                const errData = err.response.data;
                                if (errData.message.includes('was already validated.')) {
                                    setIsTicketValid(true);
                                    setIsTicketFirstValidation(false);
                                } else {
                                    setIsTicketValid(false);
                                }
                            } catch (err: any) {
                                setErrorValidating(true)
                            }
                            setValidatingTicket(false);
                        });
                        // make online request
                        // Maybe some scanning stuff
                        // MODAL WITH DATA (VALID TICKET/ INVALID TICKET and when close reset scan)
                        // IF VALIDATION SUCCESS MAKE TOAST WITH DATA

                    } else {
                        setScanningQR(false);
                    }
                }
            }}
            style={{ flex: 1 }}
        />

        <Icon
            name={'close-circle-outline'}
            color={PlaceColors(findifyDataContext).text.get()}
            size={40}
            style={{
                position: 'absolute',
                right: 15,
                top: insets.top + 15,
            }}
            onPress={() => {
                setEnableCameraScan(false)
            }}
        />
        {openModal && <View
            style={{
                // backgroundColor: 'red',
                position: "absolute",
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}
        >
            <View
                style={{
                    backgroundColor: PlaceColors(findifyDataContext).background.get(),
                    width: '90%',
                    height: '90%',
                    borderRadius: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center'
                }}
            >
                {/* Loading... */}
                {validatingTicket && <ActivityIndicator size="large" color={PlaceColors(findifyDataContext).text.get()} />}
                {!validatingTicket && errorValidating && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>ERROR VALIDATING TICKET</PlaceText>}
                {!validatingTicket && !errorValidating && <View>
                    {isTicketValid && isTicketFirstValidation && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>VALID</PlaceText>}
                    {isTicketValid && !isTicketFirstValidation && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>WAS ALREADY VALDIATED</PlaceText>}
                    {!isTicketValid && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>INVALID</PlaceText>}
                </View>}


                <Icon
                    name={'close-circle-outline'}
                    color={PlaceColors(findifyDataContext).text.get()}
                    size={40}
                    style={{
                        position: 'absolute',
                        right: 15,
                        top: 15,
                    }}
                    onPress={() => {
                        setOpenModal(false);
                        setIsTicketValid(null);
                        setIsTicketFirstValidation(null);
                        setErrorValidating(null);
                        setScanningQR(false)
                    }}
                />
            </View>
        </View>}
    </View>
}